module.exports = __webpack_public_path__ + "static/media/software.77e68e60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/software.svg
// module id = 1086
// module chunks = 36